import normalizer from '@cordel/helpers/form/schema';

import {
  CUSTOMER_PERSONAL,
  CUSTOMER_FILES,
  CUSTOMER_FINANCIAL,
  CUSTOMER_BIRTH,
  CUSTOMER_DOCUMENT,
  CUSTOMER_CNH,
  CUSTOMER_PHONES,
  CUSTOMER_EMAILS,
  CUSTOMER_REFERENCES,
  CUSTOMER_PARTNERS,
  CUSTOMER_FAMILY,
  CUSTOMER_SPOUSE,
  CUSTOMER_ADDRESS,
  CUSTOMER_PREVIOUS_ADDRESS,
  CUSTOMER_ALTERNATIVE_ADDRESS,
  CUSTOMER_JOB,
  CUSTOMER_PROFESSIONAL,
  CUSTOMER_PROFESSIONAL_ADDRESS,
  CUSTOMER_PROFESSIONAL_INCOME,
  CUSTOMER_PREVIOUS_PROFESSIONAL,
  CUSTOMER_ACCOUNTANT,
  CUSTOMER_BANK,
  CUSTOMER_HISTORY,
  CUSTOMER_OBS,
} from './sections';

import {
  CPF_CNPJ,
  // CPF,
  // CNPJ,

  NAME,
  NICKNAME,
  BORN_AT,

  COMPANY_ACTIVITY_ID,
  JOINT_STOCK_CENTS,
  IE,
  IM,

  MONTHLY_BILLINGS_1_BILLING_CENTS,
  MONTHLY_BILLINGS_1_MONTH,
  MONTHLY_BILLINGS_1_YEAR,

  MONTHLY_BILLINGS_2_BILLING_CENTS,
  MONTHLY_BILLINGS_2_MONTH,
  MONTHLY_BILLINGS_2_YEAR,

  MONTHLY_BILLINGS_3_BILLING_CENTS,
  MONTHLY_BILLINGS_3_MONTH,
  MONTHLY_BILLINGS_3_YEAR,

  MONTHLY_BILLINGS_4_BILLING_CENTS,
  MONTHLY_BILLINGS_4_MONTH,
  MONTHLY_BILLINGS_4_YEAR,

  MONTHLY_BILLINGS_5_BILLING_CENTS,
  MONTHLY_BILLINGS_5_MONTH,
  MONTHLY_BILLINGS_5_YEAR,

  MONTHLY_BILLINGS_6_BILLING_CENTS,
  MONTHLY_BILLINGS_6_MONTH,
  MONTHLY_BILLINGS_6_YEAR,

  MONTHLY_BILLINGS_7_BILLING_CENTS,
  MONTHLY_BILLINGS_7_MONTH,
  MONTHLY_BILLINGS_7_YEAR,

  MONTHLY_BILLINGS_8_BILLING_CENTS,
  MONTHLY_BILLINGS_8_MONTH,
  MONTHLY_BILLINGS_8_YEAR,

  MONTHLY_BILLINGS_9_BILLING_CENTS,
  MONTHLY_BILLINGS_9_MONTH,
  MONTHLY_BILLINGS_9_YEAR,

  MONTHLY_BILLINGS_10_BILLING_CENTS,
  MONTHLY_BILLINGS_10_MONTH,
  MONTHLY_BILLINGS_10_YEAR,

  MONTHLY_BILLINGS_11_BILLING_CENTS,
  MONTHLY_BILLINGS_11_MONTH,
  MONTHLY_BILLINGS_11_YEAR,

  MONTHLY_BILLINGS_12_BILLING_CENTS,
  MONTHLY_BILLINGS_12_MONTH,
  MONTHLY_BILLINGS_12_YEAR,

  GENRE_ID,
  EDUCATION_ID,
  PROPERTY,
  PUBLIC_PERSON,

  EMAIL_ADDRESS,

  ADDRESS_CITY,
  ADDRESS_NUMBER,
  ADDRESS_STREET,
  ADDRESS_ZIP_CODE,
  ADDRESS_COMPLEMENT,
  ADDRESS_STATE_ID,
  ADDRESS_NEIGHBORHOOD,
  ADDRESS_SET_TIME_FULL,
  // ADDRESS_SET_TIME_MONTH,
  // ADDRESS_SET_TIME_YEAR,
  ADDRESS_BUILD_TYPE_ID,
  ADDRESS_RENT_VALUE_CENTS,

  ALTERNATIVE_ADDRESS_CITY,
  ALTERNATIVE_ADDRESS_NUMBER,
  ALTERNATIVE_ADDRESS_STREET,
  ALTERNATIVE_ADDRESS_ZIP_CODE,
  ALTERNATIVE_ADDRESS_COMPLEMENT,
  ALTERNATIVE_ADDRESS_STATE_ID,
  ALTERNATIVE_ADDRESS_NEIGHBORHOOD,
  ALTERNATIVE_ADDRESS_SET_TIME_FULL,
  // ALTERNATIVE_ADDRESS_SET_TIME_MONTH,
  // ALTERNATIVE_ADDRESS_SET_TIME_YEAR,
  ALTERNATIVE_ADDRESS_BUILD_TYPE_ID,
  ALTERNATIVE_ADDRESS_RENT_VALUE_CENTS,

  PREVIOUS_ADDRESS_CITY,
  PREVIOUS_ADDRESS_NUMBER,
  PREVIOUS_ADDRESS_STREET,
  PREVIOUS_ADDRESS_ZIP_CODE,
  PREVIOUS_ADDRESS_COMPLEMENT,
  PREVIOUS_ADDRESS_STATE_ID,
  PREVIOUS_ADDRESS_NEIGHBORHOOD,

  NATIONALITY,
  PLACE_OF_BIRTH,
  STATE_OF_BIRTH_ID,

  MOTHER,
  FATHER,

  DOCUMENT_TYPE,
  RG,
  RG_DATE,
  RG_STATE_ID,
  RG_ISSUING,
  HAS_CNH,
  CNH,
  CNH_TYPE_ID,

  MARITAL_STATUS_ID,
  SPOUSE_NAME,
  SPOUSE_BORN_AT,
  SPOUSE_CPF,
  SPOUSE_INCOME_CENTS,

  PERSONAL_REFERENCE_NAME,
  PERSONAL_REFERENCE_RELATIONSHIP,
  PERSONAL_REFERENCE_CITY,
  PERSONAL_REFERENCE_PHONE_FULL,
  // PERSONAL_REFERENCE_PHONE_CODE,
  // PERSONAL_REFERENCE_PHONE_NUMBER,

  PARTNER_NAME,
  PARTNER_CPF_CNPJ,
  // PARTNER_CPF,
  // PARTNER_CNPJ,
  PARTNER_ROLE,
  PARTNER_QUOTA,
  PARTNER_BORN_AT,
  PARTNER_STARTED_AT,
  PARTNER_INCOME_CENTS,
  PARTNER_MARITAL_STATUS_ID,
  PARTNER_SPOUSE_NAME,
  PARTNER_SPOUSE_CPF,
  PARTNER_SPOUSE_BORN_AT,

  CELPHONE_FULL,
  // CELPHONE_CODE,
  // CELPHONE_NUMBER,
  CELPHONE_CONFIRMATION_ID,

  ALTERNATIVE_PHONE_FULL,
  // ALTERNATIVE_PHONE_CODE,
  // ALTERNATIVE_PHONE_NUMBER,
  ALTERNATIVE_PHONE_CONFIRMATION_ID,

  JOB_REFERENCE_JOINED_AT,
  JOB_REFERENCE_INCOME_CENTS,
  JOB_REFERENCE_ANOTHER_INCOME_CENTS,
  JOB_REFERENCE_ANOTHER_INCOME_TYPE_ID,
  JOB_REFERENCE_DETAIL,
  JOB_REFERENCE_FIRST_JOB,
  JOB_REFERENCE_PROFESSIONAL_OCUPATION_ID,
  JOB_REFERENCE_PROFESSION_ID,
  JOB_REFERENCE_DEPARTMENT,
  JOB_REFERENCE_NAME,
  JOB_REFERENCE_CNPJ,
  JOB_REFERENCE_COMPANY_ACTIVITY_ID,

  JOB_REFERENCE_ADDRESS_CITY,
  JOB_REFERENCE_ADDRESS_NUMBER,
  JOB_REFERENCE_ADDRESS_STREET,
  JOB_REFERENCE_ADDRESS_ZIP_CODE,
  JOB_REFERENCE_ADDRESS_COMPLEMENT,
  JOB_REFERENCE_ADDRESS_STATE_ID,
  JOB_REFERENCE_ADDRESS_NEIGHBORHOOD,

  JOB_REFERENCE_PHONE_FULL,
  // JOB_REFERENCE_PHONE_CODE,
  // JOB_REFERENCE_PHONE_NUMBER,

  JOB_REFERENCE_PREVIOUS_WORK,
  JOB_REFERENCE_PREVIOUS_WORK_START_AT,
  JOB_REFERENCE_PREVIOUS_WORK_END_AT,

  JOB_REFERENCE_PREVIOUS_JOB_PHONE_FULL,
  // JOB_REFERENCE_PREVIOUS_JOB_PHONE_CODE,
  // JOB_REFERENCE_PREVIOUS_JOB_PHONE_NUMBER,

  ACCOUNTANT_NAME,
  ACCOUNTANT_CITY,
  ACCOUNTANT_PHONE_FULL,
  // ACCOUNTANT_PHONE_CODE,
  // ACCOUNTANT_PHONE_NUMBER,

  HAVE_CREDIT_CARD,
  CREDIT_CARDS,
  HAS_MADE_FUNDING,
  PREVIOUS_FUNDING_BANK_ID,
  HAVE_BANK_ACCOUNT,

  BANK_REFERENCE_BANK_ID,
  BANK_REFERENCE_OVERDRAFT,
  BANK_REFERENCE_AGENCY,
  BANK_REFERENCE_ACCOUNT_FULL,
  // BANK_REFERENCE_ACCOUNT_DIGIT,
  // BANK_REFERENCE_ACCOUNT_NUMBER,
  BANK_REFERENCE_OPEN_AT,

  ACCEPT_BOLETO,
  NOTE,
} from './fields';

export default function schema() {
  return normalizer({
    sections: {
      [CUSTOMER_PERSONAL]: {
        title: 'Identificação',
        subtitle: 'Informações do cliente',
      },
      [CUSTOMER_FILES]: {
        title: 'Arquivos',
        subtitle: 'Comprovantes anexados',
      },
      [CUSTOMER_FINANCIAL]: {
        title: 'Faturamento',
        subtitle: 'Últimos 12 meses',
      },
      [CUSTOMER_BIRTH]: {
        title: 'Nacionalidade',
        subtitle: 'Informações de naturalidade',
      },
      [CUSTOMER_DOCUMENT]: {
        title: 'Documento',
        subtitle: 'Identificação do cliente',
      },
      [CUSTOMER_CNH]: {
        title: 'Carteira de motorista',
        subtitle: 'Dados da carteira de habilitação',
      },
      [CUSTOMER_PHONES]: {
        title: 'Telefones',
        subtitle: 'Números de contato',
      },
      [CUSTOMER_EMAILS]: {
        title: 'E-mail',
        subtitle: 'Dados de contato',
      },
      [CUSTOMER_REFERENCES]: {
        title: 'Contato de referência',
        subtitle: 'Por exemplo: Pai, prima, amigo, irmã, etc.',
      },
      [CUSTOMER_PARTNERS]: {
        title: 'Sócio principal',
        subtitle: 'Informações do sócio',
      },
      [CUSTOMER_FAMILY]: {
        title: 'Filiação',
        subtitle: 'Parentesco',
      },
      [CUSTOMER_SPOUSE]: {
        title: 'Cônjuge',
        subtitle: 'Dados do cônjuge',
      },
      [CUSTOMER_ADDRESS]: {
        title: 'Endereço atual',
        subtitle: 'Localização',
      },
      [CUSTOMER_PREVIOUS_ADDRESS]: {
        title: 'Endereço anterior',
        subtitle: 'Localização anterior',
      },
      [CUSTOMER_ALTERNATIVE_ADDRESS]: {
        title: 'Endereço alternativo',
        subtitle: 'Lugar para correspondências alternativo',
      },
      [CUSTOMER_JOB]: {
        title: 'Profissão',
        subtitle: 'Dados profissionais',
      },
      [CUSTOMER_PROFESSIONAL]: {
        title: 'Emprego atual',
        subtitle: 'Dados do seu emprego atual',
      },
      [CUSTOMER_PROFESSIONAL_ADDRESS]: {
        title: 'Endereço do emprego atual',
        subtitle: 'Informações trabalhistas',
      },
      [CUSTOMER_PROFESSIONAL_INCOME]: {
        title: 'Renda',
        subtitle: 'Informações trabalhistas',
      },
      [CUSTOMER_PREVIOUS_PROFESSIONAL]: {
        title: 'Emprego anterior',
        subtitle: 'Dados do seu emprego anterior',
      },
      [CUSTOMER_ACCOUNTANT]: {
        title: 'Contador',
        subtitle: 'Dados de contabilidade',
      },
      [CUSTOMER_BANK]: {
        title: 'Conta bancária',
        subtitle: 'Dados bancários',
      },
      [CUSTOMER_HISTORY]: {
        title: 'Histórico',
        subtitle: 'Informações extras',
      },
      [CUSTOMER_OBS]: {
        title: 'Observações internas',
        subtitle: 'Observações no cadastro do cliente',
      },
    },

    fields: {
      [CPF_CNPJ]: {
        section: CUSTOMER_PERSONAL,
        label: 'CPF ou CNPJ',
        data: {
          kind: ['cpf', 'cnpj'],
        },
      },
      [NAME]: {
        section: CUSTOMER_PERSONAL,
        label: 'Nome',
        data: {
          kind: ['cpf', 'cnpj'],
          labels: {
            cpf: 'Nome',
            cnpj: 'Razão social',
          },
        },
      },
      [NICKNAME]: {
        section: CUSTOMER_PERSONAL,
        label: 'Apelido',
        data: {
          kind: ['cpf', 'cnpj'],
          labels: {
            cpf: 'Apelido',
            cnpj: 'Nome fantasia',
          },
        },
      },
      [BORN_AT]: {
        section: CUSTOMER_PERSONAL,
        label: 'Data de nascimento',
        data: {
          kind: ['cpf', 'cnpj'],
          labels: {
            cpf: 'Data de nascimento',
            cnpj: 'Data de fundação',
          },
        },
      },
      [GENRE_ID]: {
        section: CUSTOMER_PERSONAL,
        label: 'Gênero',
        data: {
          kind: ['cpf'],
        },
      },
      [EDUCATION_ID]: {
        section: CUSTOMER_PERSONAL,
        label: 'Escolaridade',
        data: {
          kind: ['cpf'],
        },
      },

      [COMPANY_ACTIVITY_ID]: {
        section: CUSTOMER_PERSONAL,
        label: 'Ramo de atividade',
        data: {
          kind: ['cnpj'],
        },
      },
      [JOINT_STOCK_CENTS]: {
        section: CUSTOMER_PERSONAL,
        label: 'Capital social',
        data: {
          kind: ['cnpj'],
        },
        mask: {
          type: 'monetize',
        },
      },
      [IE]: {
        section: CUSTOMER_PERSONAL,
        label: 'Inscrição estadual',
        data: {
          kind: ['cnpj'],
        },
      },
      [IM]: {
        section: CUSTOMER_PERSONAL,
        label: 'Inscrição municipal',
        data: {
          kind: ['cnpj'],
        },
      },

      [MONTHLY_BILLINGS_1_BILLING_CENTS]: {
        section: CUSTOMER_FINANCIAL,
        label: 'Faturamento mensal 1: Valor',
        data: {
          kind: ['cnpj'],
        },
        mask: {
          type: 'monetize',
        },
      },
      [MONTHLY_BILLINGS_1_MONTH]: {
        section: CUSTOMER_FINANCIAL,
        type: 'hidden',
        label: 'Faturamento mensal 1: Mês',
        data: {
          kind: ['cnpj'],
        },
      },
      [MONTHLY_BILLINGS_1_YEAR]: {
        section: CUSTOMER_FINANCIAL,
        type: 'hidden',
        label: 'Faturamento mensal 1: Ano',
        data: {
          kind: ['cnpj'],
        },
      },
      [MONTHLY_BILLINGS_2_BILLING_CENTS]: {
        section: CUSTOMER_FINANCIAL,
        label: 'Faturamento mensal 2: Valor',
        data: {
          kind: ['cnpj'],
        },
        mask: {
          type: 'monetize',
        },
      },
      [MONTHLY_BILLINGS_2_MONTH]: {
        section: CUSTOMER_FINANCIAL,
        type: 'hidden',
        label: 'Faturamento mensal 2: Mês',
        data: {
          kind: ['cnpj'],
        },
      },
      [MONTHLY_BILLINGS_2_YEAR]: {
        section: CUSTOMER_FINANCIAL,
        type: 'hidden',
        label: 'Faturamento mensal 2: Ano',
        data: {
          kind: ['cnpj'],
        },
      },
      [MONTHLY_BILLINGS_3_BILLING_CENTS]: {
        section: CUSTOMER_FINANCIAL,
        label: 'Faturamento mensal 3: Valor',
        data: {
          kind: ['cnpj'],
        },
        mask: {
          type: 'monetize',
        },
      },
      [MONTHLY_BILLINGS_3_MONTH]: {
        section: CUSTOMER_FINANCIAL,
        type: 'hidden',
        label: 'Faturamento mensal 3: Mês',
        data: {
          kind: ['cnpj'],
        },
      },
      [MONTHLY_BILLINGS_3_YEAR]: {
        section: CUSTOMER_FINANCIAL,
        type: 'hidden',
        label: 'Faturamento mensal 3: Ano',
        data: {
          kind: ['cnpj'],
        },
      },
      [MONTHLY_BILLINGS_4_BILLING_CENTS]: {
        section: CUSTOMER_FINANCIAL,
        label: 'Faturamento mensal 4: Valor',
        data: {
          kind: ['cnpj'],
        },
        mask: {
          type: 'monetize',
        },
      },
      [MONTHLY_BILLINGS_4_MONTH]: {
        section: CUSTOMER_FINANCIAL,
        type: 'hidden',
        label: 'Faturamento mensal 4: Mês',
        data: {
          kind: ['cnpj'],
        },
      },
      [MONTHLY_BILLINGS_4_YEAR]: {
        section: CUSTOMER_FINANCIAL,
        type: 'hidden',
        label: 'Faturamento mensal 4: Ano',
        data: {
          kind: ['cnpj'],
        },
      },
      [MONTHLY_BILLINGS_5_BILLING_CENTS]: {
        section: CUSTOMER_FINANCIAL,
        label: 'Faturamento mensal 5: Valor',
        data: {
          kind: ['cnpj'],
        },
        mask: {
          type: 'monetize',
        },
      },
      [MONTHLY_BILLINGS_5_MONTH]: {
        section: CUSTOMER_FINANCIAL,
        type: 'hidden',
        label: 'Faturamento mensal 5: Mês',
        data: {
          kind: ['cnpj'],
        },
      },
      [MONTHLY_BILLINGS_5_YEAR]: {
        section: CUSTOMER_FINANCIAL,
        type: 'hidden',
        label: 'Faturamento mensal 5: Ano',
        data: {
          kind: ['cnpj'],
        },
      },
      [MONTHLY_BILLINGS_6_BILLING_CENTS]: {
        section: CUSTOMER_FINANCIAL,
        label: 'Faturamento mensal 6: Valor',
        data: {
          kind: ['cnpj'],
        },
        mask: {
          type: 'monetize',
        },
      },
      [MONTHLY_BILLINGS_6_MONTH]: {
        section: CUSTOMER_FINANCIAL,
        type: 'hidden',
        label: 'Faturamento mensal 6: Mês',
        data: {
          kind: ['cnpj'],
        },
      },
      [MONTHLY_BILLINGS_6_YEAR]: {
        section: CUSTOMER_FINANCIAL,
        type: 'hidden',
        label: 'Faturamento mensal 6: Ano',
        data: {
          kind: ['cnpj'],
        },
      },
      [MONTHLY_BILLINGS_7_BILLING_CENTS]: {
        section: CUSTOMER_FINANCIAL,
        label: 'Faturamento mensal 7: Valor',
        data: {
          kind: ['cnpj'],
        },
        mask: {
          type: 'monetize',
        },
      },
      [MONTHLY_BILLINGS_7_MONTH]: {
        section: CUSTOMER_FINANCIAL,
        type: 'hidden',
        label: 'Faturamento mensal 7: Mês',
        data: {
          kind: ['cnpj'],
        },
      },
      [MONTHLY_BILLINGS_7_YEAR]: {
        section: CUSTOMER_FINANCIAL,
        type: 'hidden',
        label: 'Faturamento mensal 7: Ano',
        data: {
          kind: ['cnpj'],
        },
      },
      [MONTHLY_BILLINGS_8_BILLING_CENTS]: {
        section: CUSTOMER_FINANCIAL,
        label: 'Faturamento mensal 8: Valor',
        data: {
          kind: ['cnpj'],
        },
        mask: {
          type: 'monetize',
        },
      },
      [MONTHLY_BILLINGS_8_MONTH]: {
        section: CUSTOMER_FINANCIAL,
        type: 'hidden',
        label: 'Faturamento mensal 8: Mês',
        data: {
          kind: ['cnpj'],
        },
      },
      [MONTHLY_BILLINGS_8_YEAR]: {
        section: CUSTOMER_FINANCIAL,
        type: 'hidden',
        label: 'Faturamento mensal 8: Ano',
        data: {
          kind: ['cnpj'],
        },
      },
      [MONTHLY_BILLINGS_9_BILLING_CENTS]: {
        section: CUSTOMER_FINANCIAL,
        label: 'Faturamento mensal 9: Valor',
        data: {
          kind: ['cnpj'],
        },
        mask: {
          type: 'monetize',
        },
      },
      [MONTHLY_BILLINGS_9_MONTH]: {
        section: CUSTOMER_FINANCIAL,
        type: 'hidden',
        label: 'Faturamento mensal 9: Mês',
        data: {
          kind: ['cnpj'],
        },
      },
      [MONTHLY_BILLINGS_9_YEAR]: {
        section: CUSTOMER_FINANCIAL,
        type: 'hidden',
        label: 'Faturamento mensal 9: Ano',
        data: {
          kind: ['cnpj'],
        },
      },
      [MONTHLY_BILLINGS_10_BILLING_CENTS]: {
        section: CUSTOMER_FINANCIAL,
        label: 'Faturamento mensal 10: Valor',
        data: {
          kind: ['cnpj'],
        },
        mask: {
          type: 'monetize',
        },
      },
      [MONTHLY_BILLINGS_10_MONTH]: {
        section: CUSTOMER_FINANCIAL,
        type: 'hidden',
        label: 'Faturamento mensal 10: Mês',
        data: {
          kind: ['cnpj'],
        },
      },
      [MONTHLY_BILLINGS_10_YEAR]: {
        section: CUSTOMER_FINANCIAL,
        type: 'hidden',
        label: 'Faturamento mensal 10: Ano',
        data: {
          kind: ['cnpj'],
        },
      },
      [MONTHLY_BILLINGS_11_BILLING_CENTS]: {
        section: CUSTOMER_FINANCIAL,
        label: 'Faturamento mensal 11: Valor',
        data: {
          kind: ['cnpj'],
        },
        mask: {
          type: 'monetize',
        },
      },
      [MONTHLY_BILLINGS_11_MONTH]: {
        section: CUSTOMER_FINANCIAL,
        type: 'hidden',
        label: 'Faturamento mensal 11: Mês',
        data: {
          kind: ['cnpj'],
        },
      },
      [MONTHLY_BILLINGS_11_YEAR]: {
        section: CUSTOMER_FINANCIAL,
        type: 'hidden',
        label: 'Faturamento mensal 11: Ano',
        data: {
          kind: ['cnpj'],
        },
      },
      [MONTHLY_BILLINGS_12_BILLING_CENTS]: {
        section: CUSTOMER_FINANCIAL,
        label: 'Faturamento mensal 12: Valor',
        data: {
          kind: ['cnpj'],
        },
        mask: {
          type: 'monetize',
        },
      },
      [MONTHLY_BILLINGS_12_MONTH]: {
        section: CUSTOMER_FINANCIAL,
        type: 'hidden',
        label: 'Faturamento mensal 12: Mês',
        data: {
          kind: ['cnpj'],
        },
      },
      [MONTHLY_BILLINGS_12_YEAR]: {
        section: CUSTOMER_FINANCIAL,
        type: 'hidden',
        label: 'Faturamento mensal 12: Ano',
        data: {
          kind: ['cnpj'],
        },
      },

      [EMAIL_ADDRESS]: {
        section: CUSTOMER_EMAILS,
        label: 'E-mail',
        data: {
          kind: ['cpf', 'cnpj'],
        },
      },
      [ACCEPT_BOLETO]: {
        section: CUSTOMER_EMAILS,
        label: 'Receber boleto?',
        data: {
          kind: ['cpf', 'cnpj'],
        },
      },

      [NATIONALITY]: {
        section: CUSTOMER_BIRTH,
        label: 'Nacionalidade',
        data: {
          kind: ['cpf'],
        },
      },
      [PLACE_OF_BIRTH]: {
        section: CUSTOMER_BIRTH,
        label: 'Cidade de nascimento',
        data: {
          kind: ['cpf'],
        },
      },
      [STATE_OF_BIRTH_ID]: {
        section: CUSTOMER_BIRTH,
        label: 'Estado de nascimento',
        data: {
          kind: ['cpf'],
        },
      },
      [MOTHER]: {
        section: CUSTOMER_BIRTH,
        label: 'Nome da mãe',
        data: {
          kind: ['cpf'],
        },
      },
      [FATHER]: {
        section: CUSTOMER_BIRTH,
        label: 'Nome do pai',
        data: {
          kind: ['cpf'],
        },
      },

      [DOCUMENT_TYPE]: {
        section: CUSTOMER_DOCUMENT,
        label: 'Tipo do documento',
        data: {
          kind: ['cpf'],
        },
      },
      [RG]: {
        section: CUSTOMER_DOCUMENT,
        label: 'Número do documento',
        data: {
          kind: ['cpf'],
        },
      },
      [RG_DATE]: {
        section: CUSTOMER_DOCUMENT,
        label: 'Data de emissão',
        data: {
          kind: ['cpf'],
        },
      },
      [RG_ISSUING]: {
        section: CUSTOMER_DOCUMENT,
        label: 'Órgão emissor',
        data: {
          kind: ['cpf'],
        },
      },
      [RG_STATE_ID]: {
        section: CUSTOMER_DOCUMENT,
        label: 'Estado de emissão',
        data: {
          kind: ['cpf'],
        },
      },

      [HAS_CNH]: {
        section: CUSTOMER_CNH,
        label: 'Possui carteira de motorista?',
        data: {
          kind: ['cpf'],
        },
      },
      [CNH]: {
        section: CUSTOMER_CNH,
        label: 'Número da carteira',
        data: {
          kind: ['cpf'],
        },
      },
      [CNH_TYPE_ID]: {
        section: CUSTOMER_CNH,
        label: 'Categoria da carteira',
        data: {
          kind: ['cpf'],
        },
      },

      [MARITAL_STATUS_ID]: {
        section: CUSTOMER_SPOUSE,
        label: 'Estado civil',
        data: {
          kind: ['cpf'],
        },
      },
      [SPOUSE_NAME]: {
        section: CUSTOMER_SPOUSE,
        label: 'Nome do cônjuge',
        data: {
          kind: ['cpf'],
        },
      },
      [SPOUSE_CPF]: {
        section: CUSTOMER_SPOUSE,
        label: 'CPF do cônjuge',
        data: {
          kind: ['cpf'],
        },
      },
      [SPOUSE_BORN_AT]: {
        section: CUSTOMER_SPOUSE,
        label: 'Nascimento do cônjuge',
        data: {
          kind: ['cpf'],
        },
      },
      [SPOUSE_INCOME_CENTS]: {
        section: CUSTOMER_SPOUSE,
        label: 'Renda do cônjuge',
        data: {
          kind: ['cpf'],
        },
        mask: {
          type: 'monetize',
        },
      },

      [CELPHONE_FULL]: {
        section: CUSTOMER_PHONES,
        label: 'Telefone celular',
        data: {
          kind: ['cpf', 'cnpj'],
        },
      },
      [CELPHONE_CONFIRMATION_ID]: {
        section: CUSTOMER_PHONES,
        type: 'hidden',
        label: 'Telefone celular (confirmação)',
        data: {
          kind: ['cpf', 'cnpj'],
        },
      },

      [ALTERNATIVE_PHONE_FULL]: {
        section: CUSTOMER_PHONES,
        label: 'Telefone alternativo',
        data: {
          kind: ['cpf', 'cnpj'],
        },
      },
      [ALTERNATIVE_PHONE_CONFIRMATION_ID]: {
        section: CUSTOMER_PHONES,
        type: 'hidden',
        label: 'Telefone alternativo (confirmação)',
        data: {
          kind: ['cpf', 'cnpj'],
        },
      },

      [ADDRESS_CITY]: {
        section: CUSTOMER_ADDRESS,
        label: 'Cidade',
        data: {
          kind: ['cpf', 'cnpj'],
        },
      },
      [ADDRESS_NUMBER]: {
        section: CUSTOMER_ADDRESS,
        label: 'Número',
        data: {
          kind: ['cpf', 'cnpj'],
        },
      },
      [ADDRESS_STREET]: {
        section: CUSTOMER_ADDRESS,
        label: 'Logradouro',
        data: {
          kind: ['cpf', 'cnpj'],
        },
      },
      [ADDRESS_ZIP_CODE]: {
        section: CUSTOMER_ADDRESS,
        label: 'CEP',
        data: {
          kind: ['cpf', 'cnpj'],
        },
      },
      [ADDRESS_COMPLEMENT]: {
        section: CUSTOMER_ADDRESS,
        label: 'Complemento',
        data: {
          kind: ['cpf', 'cnpj'],
        },
      },
      [ADDRESS_STATE_ID]: {
        section: CUSTOMER_ADDRESS,
        label: 'Estado',
        data: {
          kind: ['cpf', 'cnpj'],
        },
      },
      [ADDRESS_NEIGHBORHOOD]: {
        section: CUSTOMER_ADDRESS,
        label: 'Bairro',
        data: {
          kind: ['cpf', 'cnpj'],
        },
      },
      [ADDRESS_SET_TIME_FULL]: {
        section: CUSTOMER_ADDRESS,
        label: 'Neste endereço desde',
        data: {
          kind: ['cpf', 'cnpj'],
        },
      },
      [ADDRESS_BUILD_TYPE_ID]: {
        section: CUSTOMER_ADDRESS,
        label: 'Tipo de endereço',
        data: {
          kind: ['cpf', 'cnpj'],
        },
      },
      [ADDRESS_RENT_VALUE_CENTS]: {
        section: CUSTOMER_ADDRESS,
        label: 'Valor do aluguel/prestação',
        data: {
          kind: ['cpf', 'cnpj'],
        },
        mask: {
          type: 'monetize',
        },
      },

      [PREVIOUS_ADDRESS_CITY]: {
        section: CUSTOMER_PREVIOUS_ADDRESS,
        label: 'Cidade',
        data: {
          kind: ['cpf', 'cnpj'],
        },
      },
      [PREVIOUS_ADDRESS_NUMBER]: {
        section: CUSTOMER_PREVIOUS_ADDRESS,
        label: 'Número',
        data: {
          kind: ['cpf', 'cnpj'],
        },
      },
      [PREVIOUS_ADDRESS_STREET]: {
        section: CUSTOMER_PREVIOUS_ADDRESS,
        label: 'Logradouro',
        data: {
          kind: ['cpf', 'cnpj'],
        },
      },
      [PREVIOUS_ADDRESS_ZIP_CODE]: {
        section: CUSTOMER_PREVIOUS_ADDRESS,
        label: 'CEP',
        data: {
          kind: ['cpf', 'cnpj'],
        },
      },
      [PREVIOUS_ADDRESS_COMPLEMENT]: {
        section: CUSTOMER_PREVIOUS_ADDRESS,
        label: 'Complemento',
        data: {
          kind: ['cpf', 'cnpj'],
        },
      },
      [PREVIOUS_ADDRESS_STATE_ID]: {
        section: CUSTOMER_PREVIOUS_ADDRESS,
        label: 'Estado',
        data: {
          kind: ['cpf', 'cnpj'],
        },
      },
      [PREVIOUS_ADDRESS_NEIGHBORHOOD]: {
        section: CUSTOMER_PREVIOUS_ADDRESS,
        label: 'Bairro',
        data: {
          kind: ['cpf', 'cnpj'],
        },
      },

      [ALTERNATIVE_ADDRESS_CITY]: {
        section: CUSTOMER_ALTERNATIVE_ADDRESS,
        label: 'Cidade',
        data: {
          kind: ['cpf', 'cnpj'],
        },
      },
      [ALTERNATIVE_ADDRESS_NUMBER]: {
        section: CUSTOMER_ALTERNATIVE_ADDRESS,
        label: 'Número',
        data: {
          kind: ['cpf', 'cnpj'],
        },
      },
      [ALTERNATIVE_ADDRESS_STREET]: {
        section: CUSTOMER_ALTERNATIVE_ADDRESS,
        label: 'Logradouro',
        data: {
          kind: ['cpf', 'cnpj'],
        },
      },
      [ALTERNATIVE_ADDRESS_ZIP_CODE]: {
        section: CUSTOMER_ALTERNATIVE_ADDRESS,
        label: 'CEP',
        data: {
          kind: ['cpf', 'cnpj'],
        },
      },
      [ALTERNATIVE_ADDRESS_COMPLEMENT]: {
        section: CUSTOMER_ALTERNATIVE_ADDRESS,
        label: 'Complemento',
        data: {
          kind: ['cpf', 'cnpj'],
        },
      },
      [ALTERNATIVE_ADDRESS_STATE_ID]: {
        section: CUSTOMER_ALTERNATIVE_ADDRESS,
        label: 'Estado',
        data: {
          kind: ['cpf', 'cnpj'],
        },
      },
      [ALTERNATIVE_ADDRESS_NEIGHBORHOOD]: {
        section: CUSTOMER_ALTERNATIVE_ADDRESS,
        label: 'Bairro',
        data: {
          kind: ['cpf', 'cnpj'],
        },
      },
      [ALTERNATIVE_ADDRESS_SET_TIME_FULL]: {
        section: CUSTOMER_ALTERNATIVE_ADDRESS,
        label: 'Tempo neste endereço',
        data: {
          kind: ['cpf', 'cnpj'],
        },
      },
      [ALTERNATIVE_ADDRESS_BUILD_TYPE_ID]: {
        section: CUSTOMER_ALTERNATIVE_ADDRESS,
        label: 'Tipo de residência',
        data: {
          kind: ['cpf', 'cnpj'],
        },
      },
      [ALTERNATIVE_ADDRESS_RENT_VALUE_CENTS]: {
        section: CUSTOMER_ALTERNATIVE_ADDRESS,
        label: 'Valor do aluguel/prestação',
        data: {
          kind: ['cpf', 'cnpj'],
        },
        mask: {
          type: 'monetize',
        },
      },

      [PERSONAL_REFERENCE_NAME]: {
        section: CUSTOMER_REFERENCES,
        label: 'Nome',
        data: {
          kind: ['cpf'],
        },
      },
      [PERSONAL_REFERENCE_RELATIONSHIP]: {
        section: CUSTOMER_REFERENCES,
        label: 'Relação',
        data: {
          kind: ['cpf'],
        },
      },
      [PERSONAL_REFERENCE_CITY]: {
        section: CUSTOMER_REFERENCES,
        label: 'Cidade',
        data: {
          kind: ['cpf'],
        },
      },
      [PERSONAL_REFERENCE_PHONE_FULL]: {
        section: CUSTOMER_REFERENCES,
        label: 'Telefone',
        data: {
          kind: ['cpf'],
        },
      },

      [PARTNER_NAME]: {
        section: CUSTOMER_PARTNERS,
        label: 'Sócio',
        data: {
          kind: ['cnpj'],
        },
      },
      [PARTNER_CPF_CNPJ]: {
        section: CUSTOMER_PARTNERS,
        label: 'CPF ou CNPJ',
        data: {
          kind: ['cnpj'],
        },
      },
      [PARTNER_BORN_AT]: {
        section: CUSTOMER_PARTNERS,
        label: 'Data de nascimento',
        data: {
          kind: ['cnpj'],
        },
      },
      [PARTNER_ROLE]: {
        section: CUSTOMER_PARTNERS,
        label: 'Função',
        data: {
          kind: ['cnpj'],
        },
      },
      [PARTNER_STARTED_AT]: {
        section: CUSTOMER_PARTNERS,
        label: 'Sócio desde',
        data: {
          kind: ['cnpj'],
        },
      },
      [PARTNER_QUOTA]: {
        section: CUSTOMER_PARTNERS,
        label: 'Participação (%)',
        data: {
          kind: ['cnpj'],
        },
      },
      [PARTNER_INCOME_CENTS]: {
        section: CUSTOMER_PARTNERS,
        label: 'Renda comprovada (PF)',
        data: {
          kind: ['cnpj'],
        },
        mask: {
          type: 'monetize',
        },
      },
      [PARTNER_MARITAL_STATUS_ID]: {
        section: CUSTOMER_PARTNERS,
        label: 'Estado civil',
        data: {
          kind: ['cnpj'],
        },
      },
      [PARTNER_SPOUSE_NAME]: {
        section: CUSTOMER_PARTNERS,
        label: 'Nome do cônjuge',
        data: {
          kind: ['cnpj'],
        },
      },
      [PARTNER_SPOUSE_CPF]: {
        section: CUSTOMER_PARTNERS,
        label: 'CPF do cônjuge',
        data: {
          kind: ['cnpj'],
        },
      },
      [PARTNER_SPOUSE_BORN_AT]: {
        section: CUSTOMER_PARTNERS,
        label: 'Nascimento do cônjuge',
        data: {
          kind: ['cnpj'],
        },
      },

      [JOB_REFERENCE_PROFESSIONAL_OCUPATION_ID]: {
        section: CUSTOMER_JOB,
        label: 'Ocupação',
        data: {
          kind: ['cpf'],
        },
      },
      [JOB_REFERENCE_FIRST_JOB]: {
        section: CUSTOMER_JOB,
        label: 'Primeiro emprego?',
        data: {
          kind: ['cpf'],
        },
      },
      [JOB_REFERENCE_PROFESSION_ID]: {
        section: CUSTOMER_JOB,
        label: 'Profissão',
        data: {
          kind: ['cpf'],
        },
      },
      [JOB_REFERENCE_DEPARTMENT]: {
        section: CUSTOMER_JOB,
        label: 'Departamento',
        data: {
          kind: ['cpf'],
        },
      },
      [JOB_REFERENCE_JOINED_AT]: {
        section: CUSTOMER_JOB,
        label: 'Data de contratação',
        data: {
          kind: ['cpf'],
        },
      },

      [JOB_REFERENCE_NAME]: {
        section: CUSTOMER_PROFESSIONAL,
        label: 'Empresa',
        data: {
          kind: ['cpf'],
        },
      },
      [JOB_REFERENCE_CNPJ]: {
        section: CUSTOMER_PROFESSIONAL,
        label: 'CNPJ',
        data: {
          kind: ['cpf'],
        },
      },
      [JOB_REFERENCE_COMPANY_ACTIVITY_ID]: {
        section: CUSTOMER_PROFESSIONAL,
        label: 'Ramo de atividade',
        data: {
          kind: ['cpf'],
        },
      },
      [JOB_REFERENCE_PHONE_FULL]: {
        section: CUSTOMER_PROFESSIONAL,
        label: 'Telefone',
        data: {
          kind: ['cpf'],
        },
      },

      [JOB_REFERENCE_DETAIL]: {
        section: CUSTOMER_PROFESSIONAL_INCOME,
        label: 'Benefício INSS',
        data: {
          kind: ['cpf'],
        },
      },
      [JOB_REFERENCE_INCOME_CENTS]: {
        section: CUSTOMER_PROFESSIONAL_INCOME,
        label: 'Renda mensal',
        data: {
          kind: ['cpf'],
        },
        mask: {
          type: 'monetize',
        },
      },
      [JOB_REFERENCE_ANOTHER_INCOME_CENTS]: {
        section: CUSTOMER_PROFESSIONAL_INCOME,
        label: 'Renda extra?',
        data: {
          kind: ['cpf'],
        },
        mask: {
          type: 'monetize',
        },
      },
      [JOB_REFERENCE_ANOTHER_INCOME_TYPE_ID]: {
        section: CUSTOMER_PROFESSIONAL_INCOME,
        label: 'Origem de extras',
        data: {
          kind: ['cpf'],
        },
      },

      [JOB_REFERENCE_ADDRESS_CITY]: {
        section: CUSTOMER_PROFESSIONAL_ADDRESS,
        label: 'Cidade',
        data: {
          kind: ['cpf'],
        },
      },
      [JOB_REFERENCE_ADDRESS_NUMBER]: {
        section: CUSTOMER_PROFESSIONAL_ADDRESS,
        label: 'Número',
        data: {
          kind: ['cpf'],
        },
      },
      [JOB_REFERENCE_ADDRESS_STREET]: {
        section: CUSTOMER_PROFESSIONAL_ADDRESS,
        label: 'Logradouro',
        data: {
          kind: ['cpf'],
        },
      },
      [JOB_REFERENCE_ADDRESS_ZIP_CODE]: {
        section: CUSTOMER_PROFESSIONAL_ADDRESS,
        label: 'CEP',
        data: {
          kind: ['cpf'],
        },
      },
      [JOB_REFERENCE_ADDRESS_COMPLEMENT]: {
        section: CUSTOMER_PROFESSIONAL_ADDRESS,
        label: 'Complemento',
        data: {
          kind: ['cpf'],
        },
      },
      [JOB_REFERENCE_ADDRESS_STATE_ID]: {
        section: CUSTOMER_PROFESSIONAL_ADDRESS,
        label: 'Estado',
        data: {
          kind: ['cpf'],
        },
      },
      [JOB_REFERENCE_ADDRESS_NEIGHBORHOOD]: {
        section: CUSTOMER_PROFESSIONAL_ADDRESS,
        label: 'Bairro',
        data: {
          kind: ['cpf'],
        },
      },

      [JOB_REFERENCE_PREVIOUS_WORK]: {
        section: CUSTOMER_PREVIOUS_PROFESSIONAL,
        label: 'Empresa anterior',
        data: {
          kind: ['cpf'],
        },
      },
      [JOB_REFERENCE_PREVIOUS_WORK_START_AT]: {
        section: CUSTOMER_PREVIOUS_PROFESSIONAL,
        label: 'Data de contratação',
        data: {
          kind: ['cpf'],
        },
      },
      [JOB_REFERENCE_PREVIOUS_WORK_END_AT]: {
        section: CUSTOMER_PREVIOUS_PROFESSIONAL,
        label: 'Data de demissão',
        data: {
          kind: ['cpf'],
        },
      },
      [JOB_REFERENCE_PREVIOUS_JOB_PHONE_FULL]: {
        section: CUSTOMER_PREVIOUS_PROFESSIONAL,
        label: 'Telefone',
        data: {
          kind: ['cpf'],
        },
      },

      [ACCOUNTANT_NAME]: {
        section: CUSTOMER_ACCOUNTANT,
        label: 'Nome do contador',
        data: {
          kind: ['cpf', 'cnpj'],
        },
      },
      [ACCOUNTANT_CITY]: {
        section: CUSTOMER_ACCOUNTANT,
        label: 'Cidade',
        data: {
          kind: ['cpf', 'cnpj'],
        },
      },
      [ACCOUNTANT_PHONE_FULL]: {
        section: CUSTOMER_ACCOUNTANT,
        label: 'Telefone',
        data: {
          kind: ['cpf', 'cnpj'],
        },
      },

      [HAVE_CREDIT_CARD]: {
        section: CUSTOMER_HISTORY,
        label: 'Possui cartões de crédito?',
        data: {
          kind: ['cpf'],
        },
      },
      [CREDIT_CARDS]: {
        section: CUSTOMER_HISTORY,
        label: 'Quais cartões?',
        data: {
          kind: ['cpf'],
        },
      },
      [HAS_MADE_FUNDING]: {
        section: CUSTOMER_HISTORY,
        label: 'Já financiou algum veículo?',
        data: {
          kind: ['cpf', 'cnpj'],
        },
      },
      [PREVIOUS_FUNDING_BANK_ID]: {
        section: CUSTOMER_HISTORY,
        label: 'Com qual banco?',
        data: {
          kind: ['cpf', 'cnpj'],
        },
      },
      [PROPERTY]: {
        section: CUSTOMER_HISTORY,
        label: 'Patrimônio',
        data: {
          kind: ['cpf'],
        },
      },
      [PUBLIC_PERSON]: {
        section: CUSTOMER_HISTORY,
        label: 'Pessoa públicamento exposta?',
        data: {
          kind: ['cpf'],
        },
      },

      [HAVE_BANK_ACCOUNT]: {
        section: CUSTOMER_BANK,
        label: 'Possui conta bancária?',
        data: {
          kind: ['cpf', 'cnpj'],
        },
      },
      [BANK_REFERENCE_BANK_ID]: {
        section: CUSTOMER_BANK,
        label: 'Banco',
        data: {
          kind: ['cpf', 'cnpj'],
        },
      },
      [BANK_REFERENCE_OVERDRAFT]: {
        section: CUSTOMER_BANK,
        label: 'Cheque especial?',
        data: {
          kind: ['cpf', 'cnpj'],
        },
      },
      [BANK_REFERENCE_AGENCY]: {
        section: CUSTOMER_BANK,
        label: 'Agência',
        data: {
          kind: ['cpf', 'cnpj'],
        },
      },
      [BANK_REFERENCE_ACCOUNT_FULL]: {
        section: CUSTOMER_BANK,
        label: 'Conta (com dígito)',
        data: {
          kind: ['cpf', 'cnpj'],
        },
      },
      [BANK_REFERENCE_OPEN_AT]: {
        section: CUSTOMER_BANK,
        label: 'Data de abertura',
        data: {
          kind: ['cpf', 'cnpj'],
        },
      },

      [NOTE]: {
        section: CUSTOMER_OBS,
        label: 'Observação',
        data: {
          kind: ['cpf', 'cnpj'],
        },
      },
    },
  });
}
